var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-card', {
    attrs: {
      "header": "Browse PPFTZ Manual"
    }
  }, [_c('loading', {
    attrs: {
      "active": this.$store.state.barpin.isLoading,
      "is-full-page": false
    },
    on: {
      "update:active": function($event) {
        this.$store.state.barpin.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {}, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-6 my-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchFilter),
      expression: "searchFilter"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Pencarian"
    },
    domProps: {
      "value": (_vm.searchFilter)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchFilter = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-6 my-2"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.current_status),
      expression: "current_status"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.current_status = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Status")]), _vm._v(" "), _vm._l((_vm.status), function(item) {
    return _c('option', {
      key: item.status,
      domProps: {
        "value": item.status
      }
    }, [_vm._v(_vm._s(item.ur_status))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6 my-2"
  }, [_c('b-form-fieldset', [_c('b-form-select', {
    attrs: {
      "plain": true,
      "options": [{
          text: 'Jenis Aju',
          value: ''
        },
        {
          text: 'Barang Pindahan',
          value: '1'
        },
        {
          text: 'Kendaraan Bermotor',
          value: '2'
        }
      ]
    },
    model: {
      value: (_vm.jns_aju),
      callback: function($$v) {
        _vm.jns_aju = $$v
      },
      expression: "jns_aju"
    }
  })], 1)], 1)])])]), _vm._v(" "), (!this.$store.state.barpin.isLoading) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('table', {
    staticClass: "table table-bordered table-responsive"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("No. Aju")]), _vm._v(" "), _c('th', [_vm._v("No. Daftar")]), _vm._v(" "), _c('th', [_vm._v("Nama Penerima")]), _vm._v(" "), _c('th', [_vm._v("Jenis Pengajuan")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', _vm._l((_vm.pageOfItems), function(data) {
    return _c('tr', {
      key: data.NO_AJU
    }, [_c('td', [_vm._v(_vm._s(data.NO_AJU))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.NO_DAFTAR))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.NAMA_PENERIMA))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.JNS_AJU == '1' ? 'Barang Pindahan' : 'Kendaraan Bermotor'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.status.ur_status))]), _vm._v(" "), _c('td', [_c('router-link', {
      staticClass: "btn btn-primary",
      attrs: {
        "to": ("browse/" + (data.NO_AJU))
      }
    }, [_c('i', {
      staticClass: "fa fa-search"
    })]), _vm._v(" "), _c('b-button', {
      directives: [{
        name: "b-modal",
        rawName: "v-b-modal.modal-respon",
        modifiers: {
          "modal-respon": true
        }
      }],
      attrs: {
        "variant": "success"
      },
      on: {
        "click": function($event) {
          _vm.setRespon(data.encoded_id, data.KD_STATUS, data.NO_AJU)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-download"
    })]), _vm._v(" "), _c('b-button', {
      directives: [{
        name: "b-modal",
        rawName: "v-b-modal.modal-catatan",
        modifiers: {
          "modal-catatan": true
        }
      }],
      attrs: {
        "variant": "secondary"
      },
      on: {
        "click": function($event) {
          _vm.getCatatan(data.ID_AJU)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-bars"
    })]), _vm._v(" "), (data.KD_STATUS === '115') ? _c('b-button', {
      directives: [{
        name: "b-modal",
        rawName: "v-b-modal.modal-billing",
        modifiers: {
          "modal-billing": true
        }
      }],
      attrs: {
        "title": "Rekam Bukti Bayar",
        "variant": "secondary"
      },
      on: {
        "click": function($event) {
          _vm.setBilling(data.NO_AJU)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-edit"
    })]) : _vm._e()], 1)])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "card-footer pb-0 pt-3"
  }, [_c('jw-pagination', {
    attrs: {
      "items": _vm.filteredData
    },
    on: {
      "changePage": _vm.onChangePage
    }
  })], 1)])]) : _vm._e()])], 1), _vm._v(" "), _c('modal-respon'), _vm._v(" "), _c('modal-catatan'), _vm._v(" "), _c('modal-billing')], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c150c5d4","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/ppftz/Browse.vue
// module id = 380
// module chunks = 0